<sk-modal-content [title]="label | translate"
                  confirmByKeypress
                  (confirmed)="saveTag()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()"
                  [allowCancelIfChildFocused]="true"
                  [allowConfirmIfChildFocused]="true"
                  [suppressCancel]="fieldColor.colorDialogOpened$ | async"
                  [suppressConfirm]="fieldColor.colorDialogOpened$ | async">

  <ng-container id="sk-modal-body">
    <form [formGroup]="tagForm" class="tag-form">
      <div class="mb-2">
        <sk-text
          class="tag-title"
          [label]="'label.dms.TagName' | translate"
          formControlName="name"
          data-test="dms-tag-modal_tag-name"
        ></sk-text>
      </div>

      <sk-select
        [label]="'label.dms.TagType' | translate"
        [items]="tagTypes"
        bindValue="name"
        bindLabel="label"
        formControlName="type"
        data-test="dms-tag-modal_tag-type"
      ></sk-select>

      <sk-color
        class="tag-color"
        [label]="'label.Color' | translate"
        formControlName="color"
        data-test="dms-tag-modal_tag-color"
      ></sk-color>

      @if (!!tag.id) {
        <p class="status-title">{{ 'label.Status' | translate }}</p>
        <sk-toggle
          class="tag-status"
          [label]="'label.Active' | translate"
          formControlName="isActive"
          data-test="dms-tag-modal_tag-status"
        ></sk-toggle>
      }

      <div>
        @if (tagForm.errors?.tagExists) {
          <mat-error class="sk">
            {{ 'error.dms.TagAlreadyExists' | translate }}
          </mat-error>
        }
      </div>
    </form>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [type]="'submit'"
      [color]="'primary'"
      [label]="'label.Save' | translate"
      class="save-tag"
      data-test="modal-footer-confirm-button"
      (click)="saveTag()"
      [disabled]="tagForm.invalid">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
